(function($) {
	$( document ).ready(function() {
	    
	    slickSliders();
	    propertyFilters();
	    searchBar();
	    autoplayFullVideo();
	    
	    $('.menuContact').click(function(){
		    $('.contactOverlay').addClass('open');
	    });
	    
	    $('.contactClose').click(function(){
		    $('.contactOverlay').removeClass('open');
	    });
	    
	    $('.menuNewsletter').click(function(){
		    $('.newsletterOverlay').addClass('open');
	    });
	    
	    $('.nlClose').click(function(){
		    $('.newsletterOverlay').removeClass('open');
	    });  
	    
	    $(function() {
			$('.js-matchHeight').matchHeight();
		}); 
		
		$(".banner-arrow").click(function(e){
			e.preventDefault();
			$([document.documentElement, document.body]).animate({
				scrollTop: $("main").offset().top
    			}, 1000);
		});
		
		$(".footerArrow").click(function(e){
			e.preventDefault();
			$([document.documentElement, document.body]).animate({
				scrollTop: 0
    			}, 1750);
		});
		
		if($(window).width() < 1000){
			var windowHeight = window.innerHeight;
			$(".mainBanner .banner .bannerBackground, .mainBanner, .mainBanner .banner, .banner-placeholder").css("height", windowHeight);
		}
	    
	    	var image = document.getElementsByClassName('bannerBackground');
		new simpleParallax(image);
	    
	    $('#enquiryForm #enquireBtn').click(function(e){
		   e.preventDefault();
		   
		   if ($('#enquiryForm input[type=checkbox]').prop('checked')){
			   
			   var nameValue = $('#enquiryForm #name').val();
			   $('#enqForm .full-name input').val(nameValue);
			   
			   var phoneValue = $('#enquiryForm #phone').val();
			   $('#enqForm .tel-699 input').val(phoneValue);
			   
			   var emailValue = $('#enquiryForm #email').val();
			   $('#enqForm .your-email input').val(emailValue);
			   
			   var subjectValue = $('#enquiryForm #subject').val();
			   $('#enqForm .subject input').val(subjectValue);
			   
			   $('#enqForm .wpcf7-submit').click();
			   
			   $('#enquiryForm').fadeOut(250);
			   $('.initialThanks').fadeOut(250, function(){
				   AOS.refresh();
				   $('.enquiryThanks').fadeIn(250);
				});
				
			}
	    });
	    
	    $('#newsletterForm #enquireBtn').click(function(e){
		   e.preventDefault();
		   
		   if ($('#newsletterForm input[type=checkbox]').prop('checked')){
			   $('#newsletterForm').slideUp(250);
			   $('.newsletter .initial').fadeOut(250);
			   $('.newsletter .thanks').fadeIn(250);
			   
			   var emailValue = $('#newsletterForm #email').val();
			   $('#nl .wpcf7-email').val(emailValue);
			   $('#nl .wpcf7-submit').click();
			   
		   }
		  	   
	    });
	    
	    $('.burgerIcon').click(function(){
			$('nav, .smallLogo').toggleClass('open');
	    });
	    
	    $('.teamMember').click(function() {
			var bioContent = $(this).find('.bio').eq(0).html();
			var name = $(this).find('.teamName').eq(0).text();
			var title = $(this).find('.teamPosition').eq(0).text();
	
			$('.teamModalContainer').addClass('open').find('.bio').html(bioContent);
			$('.teamModalContainer').find('.modalTitle').text(name);
			$('.teamModalContainer').find('.date').text(title);
	
			$('.teamModalContainer').on('click',fadeOutModal);
	
		});
		
		function fadeOutModal(e) {
			if(e.target != $('.teamModal')) {
				$('.teamModalContainer').removeClass('open');
				$('.teamModalContainer').off('click',fadeOutModal);
			}
		}
		
		// Check browser support
		if (typeof(Storage) !== "undefined") {
		   localStorage.setItem("newsletterSumbitted", "false");
		}
		
		$('#nlOptInPop').click(function(){
			localStorage.setItem("newsletterSumbitted", "true");
		});
		
		$('.videoPlayBtn').click(function(){
			
			var videoSrc = $(this).data('src');
			
			$('#videoPopup').html('<video id="popupVid" width="100%" height="100%" controls="" autoplay=""><source src="'+videoSrc+'" type="video/mp4"></video>');
			$('#videoPopup').fadeIn(350);
			$('#videoPopupBg').fadeIn(350);
			
			$('#videoPopupBg').click(function(){
				$('#videoPopup').fadeOut(350);
				$('#videoPopupBg').fadeOut(350);
				$('#popupVid').get(0).pause();
			});
		});
	    
	});
	
	function slickSliders(){
		
		$('.mainBanner').slick({
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover:false,
			slidesToShow: 1
		});
			
		$('.imageSlider').slick({
			slidesToShow: 2,
			adaptiveHeight: true,
			dots: true,
			arrows: false,
			responsive: [
			  
			    {
			      breakpoint: 900,
			      settings: {
			        slidesToShow: 1
			      }
			    }
			]
		});
		
		AOS.init({
			duration: 1500,
			offset: 0
		});	
		
		checkHoverState();
		
		setTimeout( animateNewsContainer, 5000);
		setTimeout( animateNewsContainer2, 7500);
		
	}
	
	var newsContainerHover = false;
	var newsContainerHover2 = false;
	
	function checkHoverState(){
		
		$('.newsContainer').mouseenter(function(){
			newsContainerHover = true;
		});
		
		$('.newsContainer').mouseleave(function(){
			newsContainerHover = false;
		});
		
		$('.newsContainer2').mouseenter(function(){
			newsContainerHover2 = true;
		});
		
		$('.newsContainer2').mouseleave(function(){
			newsContainerHover2 = false;
		});
		
	}
	
	
	function animateNewsContainer(){
		
		if (!newsContainerHover){
			$('.newsContainer').slick('slickPrev');
		}
		
		setTimeout( animateNewsContainer , 5000);
			
	}
	
	function animateNewsContainer2(){
		
		if (!newsContainerHover2){
			$('.newsContainer2').slick('slickNext');
		}
		
		setTimeout( animateNewsContainer2 , 5000);
		
	}
	
	function propertyFilters(){
		
		$('.filter').click(function(){
			
			AOS.refresh();	
			
			var filterCategory = $(this).data('filter');
			
			if (filterCategory == 'all'){
				$('.development').removeClass('hidden');
				$('.newsItem').removeClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="all"]').addClass('current');
			}
			else if (filterCategory == 'built'){
				$('.development').addClass('hidden');
				$('.complete').removeClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="built"]').addClass('current');
			}
			else if (filterCategory == 'construction'){
				$('.development').addClass('hidden');
				$('.construction').removeClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="construction"]').addClass('current');
			}
			else if (filterCategory == 'planned'){
				$('.development').addClass('hidden');
				$('.planned').removeClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="planned"]').addClass('current');
			}
			else if (filterCategory == 'sold'){
				$('.development').addClass('hidden');
				$('.sold').removeClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="sold"]').addClass('current');
			}
			
			else if (filterCategory == '2018'){
				$('.newsItem').removeClass('hidden');
				$('.year2017').addClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="2018"]').addClass('current');
			}
			
			else if (filterCategory == '2017'){
				$('.newsItem').removeClass('hidden');
				$('.year2018').addClass('hidden');
				$('.filter').removeClass('current');
				$('*[data-filter="2017"]').addClass('current');
			}
			
		});
		
	}
	
	function searchBar(){	
		
		$('.search').click(function(){
					
			if ($('.searchBar').hasClass('open')){
				$('.searchBar').removeClass('open');
				$('.searchResults').removeClass('open');
				$('#searchInput').blur();
				removeSearchListener();
			}
			else{
				$('.searchBar').addClass('open');
				$('#searchInput').focus();
				addSearchListener();
			}
					
		});
		
		$('.searchClose').click(function(){
			
			$('.searchBar').removeClass('open');
			$('.searchResults').removeClass('open');
			$('#searchInput').blur();
			removeSearchListener();
			$('#searchInput').empty();
		
		});
	}
	
	var searchArray = [];
	var searchArrayNews = [];
	var searchString;
	
	function addSearchListener(){
		
		$('#searchInput').keyup(function(){
			
			if(!$('.searchResults').hasClass('open')){
				$('.searchResults').addClass('open');
			}
			
			var searchString = $(this).val();
			
			function findItem (term) {
		    var items = [];
			    for (var i=0;i<searchArray.length;i++) {
			        var item = searchArray[i];
			        for (var prop in item) {
			            var detail = item[prop].toString().toLowerCase();
			            if (detail.indexOf(term)>-1) {
			                items.push(item);
			                break;               
			            }
			        }
			    }
			    return items;
			}
			
			var results = (findItem(searchString));
			
			if (results.length == 0){
				$(".searchProperties .message").css('opacity', 1);
			}
			else{
				$(".searchProperties .message").css('opacity', 0);
			}
		
			$('.searchProperties .searchResultsHolder .development').fadeOut(200);
			
			for (var i=0;i<results.length;i++) {
				var item = results[i];
				var itemId = item.id;
				$('.searchProperties .searchResultsHolder .development:nth-child('+(itemId+1)+')').fadeIn(200);
		    }
		    
		    
		    function findItemNews (term) {
		    var itemsNews = [];
			    for (var i=0;i<searchArrayNews.length;i++) {
			        var item = searchArrayNews[i];
			        for (var prop in item) {
			            var detail = item[prop].toString().toLowerCase();
			            if (detail.indexOf(term)>-1) {
			                itemsNews.push(item);
			                break;               
			            }
			        }
			    }
			    return itemsNews;
			}
			
			var resultsNews = (findItemNews(searchString));
			
			if (resultsNews.length == 0){
				$(".searchNews .message").css('opacity', 1);
			}
			else{
				$(".searchNews .message").css('opacity', 0);
			}
		
			$('.searchNews .searchResultsHolder .development').fadeOut(200);
			
			for (var i=0;i<resultsNews.length;i++) {
				var item = resultsNews[i];
				var itemId = item.id;
				$('.searchNews .searchResultsHolder .development:nth-child('+(itemId+1)+')').fadeIn(200);
		    }
		
		});
		
		$('.searchProperties .searchResultsHolder .development').each(function(index){
			var devTitle = $(this).data('name');
			var devLocation = $(this).data("location");
			var devStatus = $(this).data("status");
			searchArray.push({id: index++, name: devTitle, location: devLocation, status: devStatus});
		});
		
		$('.searchNews .searchResultsHolder .development').each(function(index){
			var devTitle = $(this).data('name');
			var devLocation = $(this).data("location");
			var devStatus = $(this).data("status");
			searchArrayNews.push({id: index++, name: devTitle, location: devLocation, status: devStatus});
		});
		
	}
	
	function removeSearchListener(){
		
		$('#searchInput').unbind();
		
	}
	
	function autoplayFullVideo() {
			
		if ($('#bgvid').length){	
			$('#bgvid').get(0).play();
		}
		
	}
	
	
	/* Load More on Click */
	
	$(".togglePortfolioBlock").click(function(event){
		event.preventDefault();
		$(".portfolioBlock.not-loaded, .year-marker.not-loaded").addClass("is-loaded");
		$(".portfolioBlock.not-loaded, .year-marker.not-loaded").attr("data-aos", "fade-up");
		$(".portfolioBlock.not-loaded, .year-marker.not-loaded").removeClass("not-loaded");
		$(this).parent().remove();
	});
	
	/* Change menu color on Scroll */
	
	$(window).scroll(function(){
		var ulTop = $(".ulInner").offset().top;
		var ulHeight = $(".ulInner").outerHeight() / 2;
		var navHeight = $("nav").outerHeight();
		var windowScroll = $(window).scrollTop();
		var scrollTop = navHeight + windowScroll - 3;
		var scrolledOverSection = false;
		if($("body").hasClass("home")){
			var topSectionHeight = $(".mainBanner").outerHeight();
			if(windowScroll > topSectionHeight){
				$(".home-logo").addClass("is-visible");
			}else{
				$(".home-logo").removeClass("is-visible");
			}
		};
		$("section").each(function(){
			var _this = $(this);
			var sectionOffsetTop = $(this).offset().top;
			var sectionHeight = $(this).outerHeight();
			if(scrollTop > sectionOffsetTop && scrollTop <= sectionHeight + sectionOffsetTop){
				console.log(_this);
				scrolledOverSection = true;
				if($(_this).prop("style")["background-color"] !== ''){
					$("nav, .smallLogo").removeClass("is-over-white");
				}else{
					$("nav, .smallLogo").addClass("is-over-white");
				}
			};
		});
		if(scrolledOverSection == false){
			$("nav, .smallLogo").removeClass("is-over-white");
		};
		
		$('.scrollTint').css({
			opacity: function() {
				var elementHeight = $(this).height();
				return 0.8 - (elementHeight - windowScroll) / elementHeight;
			}
		});
	});
	
	
})(jQuery);